import React from 'react'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'

import ChatHeader from './ChatHeader'
import ChatUsername from './ChatUsername'
import Compose from './Compose'
import Empty from 'components/shared/Empty'
import IconBar from './IconBar'
import {
  areActivitiesLoading,
  getSelectedInteraction,
  showCompose,
  getFullName,
  isSocketInteraction,
  lastExternalActivity
} from 'state/selectors'
import ChatHistory from './ChatHistory'
import Spinner from 'components/shared/Spinner'
import {isExpiredInteraction} from 'shared/utils/time'
import empty from 'assets/emptyActivities.png'

const ChatBarContainer = styled.main`
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;
  width: 48.5%;
  box-shadow: 0 0 16px rgba(53, 58, 82, 0.16);
  padding-bottom: 8px;
`
const Wrapper = styled.div`
    font-size: 20px;
    text-align: center;
    margin-top: auto;
`
const Image = styled.img`
  display: block;
  margin: auto;
`

const ChatBar = () => {
  const selectedInteraction = useSelector(getSelectedInteraction)
  const isLoading = useSelector(areActivitiesLoading)
  const show = useSelector(showCompose)
  const fullName = useSelector(getFullName)
  const lastExternal = useSelector(lastExternalActivity)
  const isSocket = useSelector(isSocketInteraction)

  const isExpired = isSocket && lastExternal && isExpiredInteraction(lastExternal)
  const compose = isExpired ? <Wrapper>Interaction is closed</Wrapper> : <Compose/>

  return (
    <ChatBarContainer>
      { isLoading && <Spinner/> }

      { !selectedInteraction
          ? <Empty><Image
            src={empty}
            title={'Nothing is selected'}
          />Nothing is selected</Empty>
          : (<>
          <ChatHeader>
            <ChatUsername>{fullName}</ChatUsername>
            <IconBar/>
          </ChatHeader>
          <ChatHistory/>
          { show && compose }
        </>)
      }
    </ChatBarContainer>
  )
}

export default ChatBar
